// ----------------------------------------------------------------------------
// Snippet: Free Shipping Progress
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import $ from 'jquery';
import {formatMoney} from '@shopify/theme-currency';


Shopify.freeGiftProgress = (function($){

    var _config = {
        progressContainerSelector : '.free-gift-progress',
        minimumSubtotalAttribute  : 'data-minimum-subtotal-gift',
        shopifyAjaxCartURL        : window.localeUrl+'/cart.js',
        freeGiftMessage           : 'You get a free gift!',
        moneyFormat               : theme.moneyFormat, // Based on the shop money format
        progressBar               : '.free-gifts-progress__full',
        freeGiftThreshold         : '.free-gift-threshold',
        freeGiftButton            : '.add-to-cart--sample-product'
    };

    var _init = function(selectedLineItemId){
        var _freeGiftProgressHtml = function(cart, minimumSubtotal){

            var html = '';
            var $cartSubtotal = parseInt(cart.items_subtotal_price);

            html += '<span class="free-gift-progress__message">';
                if( $cartSubtotal >= minimumSubtotal){// Free Shipping
                    html += _config.freeGiftMessage;
                }else{
                    var $priceDifference = formatMoney(minimumSubtotal - $cartSubtotal, _config.moneyFormat);
                    html += 'You are ' + $priceDifference + ' ' + 'away from a free gift';

                }
            html += '</span>';

            return html;
        }

        var _freeGiftButtonEnabled = function(cart, minimumSubtotal) {
            var $cartSubtotal = parseInt(cart.items_subtotal_price);
            var $freeGiftButton = $(_config.freeGiftButton);

            // TODO: replace this with appropriate 'free gift" detection
            var currentGift = cart.items.find(item => item.price == 0);

            if ($cartSubtotal >= minimumSubtotal && currentGift === undefined){
                //enable free gift items to be added
                $.each($freeGiftButton, function(){
                    $(this).prop('disabled', false);
                });
            }else {
                // disable free gift items
                $.each($freeGiftButton, function(){
                    $(this).prop('disabled', true);
                });

                // Remove free gifts if below threshold
                if (currentGift && $cartSubtotal < minimumSubtotal) {
                    $('.cart__remove--ajax[data-line-item-id='+currentGift.id+']').trigger('click');
                }
            }
        }

        var _freeGiftPriceDifference = function(cart, minimumSubtotal){

            var $cartSubtotal = parseInt(cart.items_subtotal_price);
            var $priceDifference = formatMoney(minimumSubtotal - $cartSubtotal, _config.moneyFormat);

            return html;
        }

        $(document).ready(function(){

            var $progressContainers = $(_config.progressContainerSelector);
            var $progressBar = $(_config.progressBar);
            var $freeGiftThresholdSelector = $(_config.freeGiftThreshold);


            if( $progressContainers.length ){
                var $minimumSubtotal = false;

                $.each($progressContainers, function(){

                    if( $(this).attr(_config.minimumSubtotalAttribute) != 'false'){
                        $minimumSubtotal = parseInt($progressContainers.attr(_config.minimumSubtotalAttribute));
                        return false;
                    }
                })

                if( $minimumSubtotal != false){
                    $.ajax({
                        url: _config.shopifyAjaxCartURL,
                        cache: false,
                        dataType: "json",
                        success: function(cart) {
                            var freeGiftProgressHtml = _freeGiftProgressHtml(cart, $minimumSubtotal);


                            $.each($progressContainers, function(){

                                $(this).html(freeGiftProgressHtml);
                            })

                            if($progressBar.length) {
                                var $cartSubtotal = parseInt(cart.items_subtotal_price);
                                var $pricePercentage = ($cartSubtotal / $minimumSubtotal) * 100;

                                $progressBar.css('width', $pricePercentage + '%');
                            }

                             _freeGiftButtonEnabled(cart, $minimumSubtotal);
                        }
                    });


                    if( $freeGiftThresholdSelector.length ){
                        var freeGiftAmount = formatMoney($minimumSubtotal);

                        $freeGiftThresholdSelector.text(freeGiftAmount);
                    }
                }
            }
        })
    }
    return {
        init: function(params) {
                // Configuration
                params = params || {};
                // Merging with defaults.
                $.extend(_config, params);
                // Action
                $(function() {
                    _init();
                });
        },
        getConfig: function() {
            return _config;
        }
    }
})($)

Shopify.freeGiftProgress.init();
